import React from 'react';
import { Helmet } from 'react-helmet';
import './legal.css';

const RefundPolicy = () => {
  return (
    <div className="legal-page">
      <Helmet>
        <title>Refund Policy | dmyor</title>
        <link rel="canonical" href="https://www.dmyor.com/refund-policy" />
        <meta name="description" content="Refund policy for dmyor purchases." />
        <meta property="og:title" content="Refund Policy | dmyor" />
        <meta property="og:description" content="Refund policy for dmyor purchases." />
        <meta property="og:image" content="https://dmyor.com/images/og-image.png" />
        <meta property="og:url" content="https://www.dmyor.com/refund-policy" />
        <meta property="og:type" content="website" />
      </Helmet>

      <div className="legal-header">
        <div className="legal-eyebrow">dmyor</div>
        <h1>Refund Policy</h1>
      </div>

      <div className="legal-body">
        <p>
          Thank you for using dmyor. Please read this policy carefully before
          making any purchase on the platform.
        </p>

        <h2>No Refunds</h2>
        <p>
          All purchases made on dmyor, including credits and any other services,
          are final and non-refundable. We do not offer refunds under any circumstances,
          and purchased services are non-transferable.
        </p>

        <h2>Exceptions</h2>
        <p>
          In the rare event that a refund is granted at our sole discretion, the
          refunded amount may be issued as cash or as platform credit of equivalent
          value.
        </p>

        <h2>Questions</h2>
        <p>
          If you have questions about a purchase or this policy, reach out at{' '}
          <a href="mailto:support@dmyor.com">support@dmyor.com</a> and we will do
          our best to help.
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
